var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowButtonUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Arrow-Button-Up--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Arrow Button Up Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.9753 18.8302 12 12.0005l7.0247 6.8297c0.2983 0.287 0.77 0.287 1.0683 0l2.7107 -2.6353c0.2951 -0.2837 0.2951 -0.756 0 -1.0398L12.5341 5.16979c-0.2982 -0.287 -0.77 -0.287 -1.0682 0L1.1963 15.1552c-0.295099 0.2837 -0.295099 0.756 0 1.0397l2.7108 2.6353c0.2982 0.287 0.7699 0.287 1.0682 0Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButtonUp);
export default __webpack_public_path__ + "static/media/arrow-button-up.f00f68ae5858dbd48815de17d5c3c1b7.svg";
export { ForwardRef as ReactComponent };